import { render, staticRenderFns } from "./TemplateMarketItem.vue?vue&type=template&id=37996937&scoped=true&"
import script from "./TemplateMarketItem.vue?vue&type=script&lang=js&"
export * from "./TemplateMarketItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMarketItem.vue?vue&type=style&index=0&id=37996937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37996937",
  null
  
)

export default component.exports